module.exports = __webpack_public_path__ + "assets/arrow-down-left.218c7e6f.svg";